import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthContext";
import { AlertInfo } from "../../Alerts/Alert";
import checkResourceEditAccess from "../../../apis/checkResourceEditAccess";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import EditResourceFormBlock from "./EditResourceFormBlock";

const EditResourceComponent = ({ resourceSlug }) => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;

  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [resourceDetails, setResourceDetails] = useState(null);

  useEffect(() => {
    if (!user_slug) return;

    setIsLoading(true);
    checkResourceEditAccess(user_slug, resourceSlug)
      .then((res) => {
        const details = res?.data?.resource_details;

        if (details) {
          setHasAccess(true);
          setResourceDetails(details);
        } else {
          setHasAccess(false);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching resource access:", err);
        setHasAccess(false);
        setIsLoading(false);
      });
  }, [user_slug, resourceSlug]);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "300px" }}
      >
        <LoadingPageSm title="Loading, please wait..." />
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <AlertInfo
        title="Note"
        message="You do not have access to view this page"
      />
    );
  }

  return (
    <EditResourceFormBlock
      resourceDetails={resourceDetails}
      resourceSlug={resourceSlug}
    />
  );
};

export default EditResourceComponent;
